import styled from "@emotion/styled"

export default styled.div`
  position: relative;
  margin: 0.5em 0em;
`